<div class="container">
  <mat-tab-group (selectedTabChange)="selectTab($event)">
    <mat-tab label="Actividades por tiempo">
      <cdk-virtual-scroll-viewport
        itemSize="100"
        class="example-viewport cdk"
        style="margin: 30px 0 50px 0;"
      >
      <app-calendar></app-calendar>
      </cdk-virtual-scroll-viewport>
    </mat-tab>

    <mat-tab label="Actividades por odómetro/horómetro">
      <div class="container">
        <div style="padding: 10px">
          <div class="default-row">
            <div class="row-item">
              <mat-form-field>
                <mat-label>Equipo</mat-label>
                <mat-select (selectionChange)="selectEquipo($event)">
                  <app-select-filter
                    [placeholder]="'Filter'"
                    [displayMember]="'code'"
                    [array]="comboEquipos"
                    (filteredReturn)="filteredList = $event"
                    [noResultsMessage]="'No hay resultados'"
                  >
                  </app-select-filter>
                  <mat-option
                    *ngFor="let data of filteredList"
                    value="{{ data.id }}"
                  >
                    {{ data.code }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="row-item">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="number"
                  [(ngModel)]="rango"
                  (keyup)="changeRango()"
                  matInput
                  #costo
                  oninput="this.value = this.value.slice(0,10)"
                  placeholder="Rango"
                />
                <mat-hint>{{ costo.value.length }}/10</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div>
          <data-table
            [columns]="columnasProyeccionesOdometro"
            [data]="dataProyeccionesOdometro"
            [configuration]="configurationProyeccionesOdometro"
            [reloadTable]="recargarTablaProyeccionesOdometro"
            [params]="paramsProyeccionesOdometro"
            [url]="urlGetTablaProyeccionesOdometro"
            (clickRow)="clickFilaProjection($event)"
          ></data-table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

